export function Dert () {
  const dertPrefix = 'dert2-'

  const prefix = function (items) {
    const result = {}
    for (const i in items) {
      result[items[i]] = dertPrefix + items[i]
    }
    return result
  }

  const dertClasses = prefix([
    'container',
    'modal',
    'overlay',
    'close',
    'content',
    'confirm',
    'spacer',
    'cancel',
    'input',
    'inputBox',
    'loader',
    'validationerror',
    'actions',
    'copyClip',
    'copyClip_value',
    'copy-icon'
  ])

  /**
   *   DEFAULT PARAMS
   */
  const defaultParams = {
    title: '',
    text: '',
    type: 'info',
    showConfirmButton: false,
    confirmButtonText: '저장',
    confirmButtonClass: null,
    confirmButtonColor: '#008ef7',
    showCancelButton: false,
    cancelButtonText: '취소',
    cancelButtonClass: null,
    cancelButtonColor: '#FFF',
    closeOnConfirm: true,
    closeOnCancel: true,
    titleClass: '',
    textClass: '',
    inputPlaceholder: '',
    inputValue: '',
    input: null, // 'text'
    inputClass: null,
    inputLabel: '',
    loader: false,
    copyClip: false,
    allowOutsideClick: true,
    timer: null,
    confirmButtonId: null,
    preConfirm: null
  }

  const dertHTML = '<div class="dert2-container dert2-center dert2-fade dert2-shown" style="overflow-y: auto;">' +
    '<div aria-labelledby="dert2-title" aria-describedby="dert2-content" class="dert2-popup dert2-modal"' +
    ' tabindex="-1" role="dialog" aria-live="assertive" aria-modal="true" style="display: flex;">' +
    ' <div class="dert2-header">' +
    '   <div class="dert2-icon">' +
    '     <h2 class="dert2-title" id="dert2-title"></h2>' +
    '     <span type="button" class="dert2-close" > <img src="../../img/jbc-pop-btn-close.png" alt="" class="dert2-close" > </span>' +
    '     <div class="dert2-loader" id ="dert2-loader"><div class="spinner"><div class="double-bounce1"></div><div class="double-bounce2"></div></div></div>' +
    '   </div>' +
    ' </div>' +
    '   <div class="dert2-content">' +
    '   <div id="dert2-content"></div>' +
    '      <div class="dert2-input-box dert2-inputBox">' +
    '        <label for="dert2-input" id="dert2-input-label"></label>' +
    '        <input class="dert2-input" id="dert2-input">' +
    '        <div class="dert2-validationerror" id="dert2-validationerror" >에러 메시지 입니다.</div>' +
    '      </div>' +
    '    </div>' +
    '    <div class="dert2-copy-clip-box dert2-copyClip">' +
    '      <div class="dert2-copy-txt-wrap"> ' +
    '          <div class="dert2-copy-txt"><input type ="password" value ="" class ="dert2-copyClip_value" readonly = "true"></div>' +
    '          <div class="dert2-copy-icon">' +
    '          </div>' +
    '      </div>' +
    '      <div class="dert2-copy-eye">' +
    '          <span>토큰 복사하기</span> <img src="/img/jbc-ico-copy-s.png" alt="" class="" >' +
    '      </div>' +
    '    </div> ' +
    '    <div class="dert2-actions cc_a_btnWrap">' +
    '        <button type="button" class="dert2-cancel dert2-styled" aria-label=""><span class="dert2-cancel-txt">삭제</span></button>' +
    '        <button type="button" class="dert2-confirm dert2-styled" aria-label=""><span class="dert2-confirm-txt">취소</span></button>' +
    '    </div>' +
    '</div>' +
    '</div>'

  const extend = function (a, b) {
    for (const key in b) {
      // eslint-disable-next-line no-prototype-builtins
      if (b.hasOwnProperty(key)) {
        a[key] = b[key]
      }
    }

    return a
  }

  // jbchatAlert function
  function dert () {
    // Copy arguments to the local args constiable
    // console.log(arguments);

    const args = arguments
    let modal = getContainer()

    if (modal === null) {
      dert.init()
      modal = getContainer()
    }

    if (hasClass(modal, 'visible')) {
      removeClass(getModal(), 'dert2-show')
      resetPrevState()
    }

    return modalDependant.apply(this, args)
  }

  // ********************** init **********************
  /*
   * Add modal + overlay to DOM
   */
  dert.init = function () {
    if (typeof document === 'undefined') {
      console.log('dert requires document to initialize')
      return
    }
    if (document.getElementsByClassName(dertClasses.container).length) {
      return
    }

    const dertWrap = document.createElement('div')
    dertWrap.className = `${dertClasses.container} dert2-wrap`

    dertWrap.innerHTML = dertHTML

    document.body.appendChild(dertWrap)
  }

  // ********************** params setParameters **********************
  const setParameters = function (params) {
    let i
    const modal = getContainer()
    const $title = modal.querySelector('h2')
    const $contentWrap = modal.querySelector(`.${dertClasses.content}`)
    const $content = modal.querySelector(`#${dertClasses.content}`)
    const $confirmBtn = modal.querySelector(`button.${dertClasses.confirm}`)
    const $confirmBtnTxt = modal.querySelector(`button.${dertClasses.confirm} span`)
    const $cancelBtn = modal.querySelector(`button.${dertClasses.cancel}`)
    const $cancelBtnTxt = modal.querySelector(`button.${dertClasses.cancel} span`)
    const $loader = modal.querySelector(`.${dertClasses.loader}`)
    const $closeButton = modal.querySelector(`.${dertClasses.close}`)
    const $actions = modal.querySelector(`.${dertClasses.actions}`)
    const $inputBox = modal.querySelector(`.${dertClasses.inputBox}`)
    const $input = $inputBox.querySelector(`.${dertClasses.input}`)
    const $inputLabel = $inputBox.querySelector('label')

    const $copyClip = modal.querySelector(`.${dertClasses.copyClip}`)
    // eslint-disable-next-line camelcase
    const $copyClip_value = modal.querySelector(`.${dertClasses.copyClip_value}`)

    // Title
    $title.innerHTML = params.title.split('\n').join('<br>')

    // Content
    $content.innerHTML = ''

    if (params.text || params.html) {
      if (typeof params.html === 'object') {
        if (0 in params.html) {
          // eslint-disable-next-line no-plusplus
          for (i = 0; i in params.html; i++) {
            $content.appendChild(params.html[i])
          }
        } else {
          $content.appendChild(params.html)
        }
      } else {
        $content.innerHTML = params.html || (params.text.split('\n').join('<br>'))
      }
      show($contentWrap)
    } else {
      hide($contentWrap)
    }

    // Close button
    if (params.showCloseButton) {
      show($closeButton)
    } else {
      hide($closeButton)
    }

    // input, select
    // const inputTypes = ['input', 'select', 'radio', 'checkbox', 'textarea'];

    // set class

    if (params.inputClass) {
      addClass($input, params.inputClass)
    }

    _hide($inputBox)
    switch (params.input) {
      case 'text':
        $input.value = params.inputValue
        $input.placeholder = params.inputPlaceholder
        $input.type = params.input
        $inputLabel.innerHTML = params.inputLabel
        _show($inputBox)
        show($contentWrap)
        break
    }

    // Cancel button
    if (params.showCancelButton) {
      $cancelBtn.style.display = 'inline-block'
    } else {
      hide($cancelBtn)
    }

    // Confirm button
    if (params.showConfirmButton) {
      removeStyleProperty($confirmBtn, 'display')
    } else {
      hide($confirmBtn)
    }

    if (params.showConfirmButton || params.showCancelButton) {
      $actions.style.display = 'flex'
    } else {
      _hide($actions)
    }

    // loading
    if (params.loader) {
      $loader.style.display = 'inline-block'
    } else {
      hide($loader)
    }

    $confirmBtnTxt.innerHTML = params.confirmButtonText
    $cancelBtnTxt.innerHTML = params.cancelButtonText

    // // Set buttons to selected background colors
    // if (params.confirmButtonColor) {
    //   // eslint-disable-next-line max-len
    // eslint-disable-next-line max-len
    //   $confirmBtn.style.borderColor = $confirmBtn.style.backgroundColor = params.confirmButtonColor;
    // }
    // if (params.cancelButtonColor) {
    //   $cancelBtn.style.borderColor = $cancelBtn.style.backgroundColor = params.cancelButtonColor;
    // }

    // Add buttons custom classes
    $confirmBtn.className = `${dertClasses.confirm} btn_red`
    addClass($confirmBtn, params.confirmButtonClass)
    setId($confirmBtn, params.confirmButtonId)

    $cancelBtn.className = `${dertClasses.cancel} btn_grey`
    addClass($cancelBtn, params.cancelButtonClass)
    setId($cancelBtn, params.cancelButtonId)

    // copy link
    if (params.copyClip) {
      $copyClip.style.display = 'inline-block'
      $copyClip_value.value = params.copyClip
    } else {
      _hide($copyClip)
    }
  }

  const mediaqueryId = `${dertPrefix}mediaquery`

  // Remember state in cases where opening and handling a modal will fiddle with it.

  const states = {
    previousDocumentClick: null,
    previousWindowKeyDown: null,
    previousActiveElement: null
  }

  /*
  * Manipulate DOM
  */
  const elementByClass = function (className) {
    return document.querySelector(`.${className}`)
  }

  const getContainer = function () {
    return elementByClass(dertClasses.container)
  }
  const getModal = function () {
    return elementByClass(dertClasses.modal)
  }
  // eslint-disable-next-line no-unused-vars
  const getOverlay = function () {
    return elementByClass(dertClasses.overlay)
  }

  const hasClass = function (elem, className) {
    return new RegExp(` ${className} `).test(` ${elem.className} `)
  }

  // eslint-disable-next-line no-unused-vars
  const focusInput = function (input) {
    input.focus()

    // http://stackoverflow.com/a/2345915/1331425
    const val = input.value
    input.value = ''
    input.value = val
  }

  const setId = function (elem, idName) {
    if (idName) {
      elem.setAttribute('id', idName)
    }
  }

  const addClass = function (elem, className) {
    if (className && !hasClass(elem, className)) {
      elem.className += ` ${className}`
    }
  }

  const removeClass = function (elem, className) {
    let newClass = ` ${elem.className.replace(/[\t\r\n]/g, ' ')} `
    if (hasClass(elem, className)) {
      while (newClass.indexOf(` ${className} `) >= 0) {
        newClass = newClass.replace(` ${className} `, ' ')
      }
      elem.className = newClass.replace(/^\s+|\s+$/g, '')
    }
  }

  const getChildByClass = function (elem, className) {
    for (let i = 0; i < elem.childNodes.length; i++) {
      if (elem.childNodes[i].classList !== undefined && elem.childNodes[i].classList.contains(className)) {
        return elem.childNodes[i]
      }
    }
  }

  const _show = function (elem) {
    elem.style.opacity = ''
    elem.style.display = 'block'
  }

  const show = (elems) => {
    if (elems && !elems.length) {
      return _show(elems)
    }
    for (let i = 0; i < elems.length; ++i) {
      _show(elems[i])
    }
  }

  const _hide = function (elem) {
    elem.style.opacity = ''
    elem.style.display = 'none'
  }

  const hide = function (elems) {
    if (elems && !elems.length) {
      return _hide(elems)
    }
    for (let i = 0; i < elems.length; ++i) {
      _hide(elems[i])
    }
  }

  const removeStyleProperty = function (elem, property) {
    if (elem.style.removeProperty) {
      elem.style.removeProperty(property)
    } else {
      elem.style.removeAttribute(property)
    }
  }

  const openModal = function (animation) {
    const modal = getContainer()
    addClass(getModal(), 'show-dert2')
    removeClass(getModal(), 'hide-dert2')
    show(getModal())

    show(modal)

    states.previousActiveElement = document.activeElement

    addClass(modal, 'visible')
  }

  const modalParams = extend({}, defaultParams)

  // Reset the page to its previous state
  const resetPrevState = function () {
    const modal = getContainer()
    window.onkeydown = states.previousWindowKeyDown
    document.onclick = states.previousDocumentClick
    if (states.previousActiveElement) {
      states.previousActiveElement.focus()
    }
    clearTimeout(modal.timeout)

    // Remove dynamically created media query
    const head = document.getElementsByTagName('head')[0]
    const mediaquery = document.getElementById(mediaqueryId)
    if (mediaquery) {
      head.removeChild(mediaquery)
    }
  }

  function modalDependant () {
    if (arguments[0] === undefined) {
      console.error('jbchatAlert expects at least 1 attribute!')
      return false
    }

    const params = extend({}, modalParams)

    switch (typeof arguments[0]) {
      case 'string':
        params.title = arguments[0]
        params.text = arguments[1] || ''
        break

      case 'object':
        extend(params, arguments[0])
        params.extraParams = arguments[0].extraParams
        console.log('params', params)
        // if (params.input === 'email' && params.inputValidator === null) {
        //   params.inputValidator = function(email) {
        //     return new Promise(function(resolve, reject) {
        //       const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
        //       if (emailRegex.test(email)) {
        //         resolve();
        //       } else {
        //         reject('Invalid email address');
        //       }
        //     });
        //   };
        // }

        break

      default:
        console.error(`Unexpected type of argument! Expected "string" or "object", got ${typeof arguments[0]}`)
        return false
    }

    setParameters(params)

    // fixVerticalPosition();

    openModal(params.animation)

    // Modal interactions
    const modal = getContainer()
    // eslint-disable-next-line camelcase
    const modal_content = getModal()

    return new Promise((resolve) => {
      // Close on timer
      if (params.timer) {
        modal.timeout = setTimeout(() => {
          dert.closeModal()
          resolve(undefined)
        }, params.timer)
      }

      // input/select autofocus
      const getInput = function () {
        switch (params.input) {
          case 'select':
            return getChildByClass(modal, dertClasses.select)
          case 'radio':
            return modal.querySelector(`.${dertClasses.radio} input:checked`) ||
              modal.querySelector(`.${dertClasses.radio} input:first-child`)
          case 'checkbox':
            return modal.querySelector(`#${dertClasses.checkbox}`)
          case 'textarea':
            return getChildByClass(modal, dertClasses.textarea)
          default:
            return getChildByClass(modal, dertClasses.input)
        }
      }
      // eslint-disable-next-line no-unused-vars
      const getInputValue = function () {
        const input = getInput()
        switch (params.input) {
          case 'checkbox':
            return input.checked ? 1 : 0
          case 'radio':
            return input.checked ? input.value : null
          case 'file':
            return input.files.length ? input.files[0] : null
          default:
            return params.inputAutoTrim ? input.value.trim() : input.value
        }
      }

      // eslint-disable-next-line no-unused-vars
      const confirm = function (value) {
        if (params.preConfirm) {
          params.preConfirm(value, params.extraParams).then(
            (preConfirmValue) => {
              resolve(preConfirmValue || value)
              dert.closeModal()
            },
            () => {
              dert.hideLoading()
            }
          )
        } else {
          resolve(false)
          dert.closeModal()
        }
      }

      // Mouse interactions
      const onButtonEvent = function (event) {
        const e = event || window.event
        const target = e.target || e.srcElement
        const targetedConfirm = hasClass(target, dertClasses.confirm)
        const targetedTxtConfirm = hasClass(target, 'dert2-confirm-txt')
        const targetedCancel = hasClass(target, dertClasses.cancel)
        const targetedTxtCancel = hasClass(target, 'dert2-cancel-txt')
        const modalIsVisible = hasClass(modal, 'visible')

        switch (e.type) {
          case 'click':

            // Clicked 'cancel'
            if ((targetedCancel || targetedTxtCancel) && modalIsVisible) {
              dert.closeModal()
              resolve(false)
            }

            if ((targetedConfirm || targetedTxtConfirm) && modalIsVisible) {
              if (params.preConfirm) {
                params.preConfirm()
                dert.close()
                resolve(false)
              }
            }
            break
          default:
        }
      }

      const $buttons = modal.querySelectorAll('button')
      let i
      for (i = 0; i < $buttons.length; i++) {
        $buttons[i].onclick = onButtonEvent
      }

      // Remember the current document.onclick event.
      states.previousDocumentClick = document.onclick
      document.onclick = function (event) {
        const e = event || window.event
        const target = e.target || e.srcElement
        if (hasClass(target, dertClasses.close) || (target === document.querySelector('.dert2-shown') && params.allowOutsideClick)) {
          dert.closeModal()
          resolve(undefined)
        }
      }

      addClass(modal_content, 'dert2-show')
    })
  }

  /*
   * Global function to close dert
   */
  dert.close = dert.closeModal = function () {
    console.log('close')
    const modal = getModal()
    console.log(modal)
    removeClass(modal, 'dert2-show')
    removeClass(modal, 'show-dert2')
    addClass(modal, 'hide-dert2')
    removeClass(modal, 'visible')

    resetPrevState()
    _hide(modal)
    fadeOut(getContainer(), 0)
  }

  /*
   * Global function to click 'Confirm' button
   */
  dert.clickConfirm = function () {
    const modal = getContainer()
    const $confirmButton = modal.querySelector(`button.${dertClasses.confirm}`)
    $confirmButton.click()
  }

  /*
   * Global function to click 'Cancel' button
   */
  dert.clickCancel = function () {
    const modal = getContainer()
    const $cancelButton = modal.querySelector(`button.${dertClasses.cancel}`)
    $cancelButton.click()
  }

  const fadeOut = function (elem, interval) {
    elem.style.opacity = 1
    if (+elem.style.opacity > 0) {
      interval = interval || 16
      const { opacity } = elem.style
      let last = +new Date()
      const tick = function () {
        const change = new Date() - last
        const newOpacity = +elem.style.opacity - change / (opacity * 100)
        elem.style.opacity = newOpacity
        last = +new Date()

        if (+elem.style.opacity > 0) {
          setTimeout(tick, interval)
        } else {
          _hide(elem)
        }
      }
      tick()
    }
  }

  return {
    fire () {
      dert(arguments[0])
    }
  }
}
